export const selectTranslatedCourses = (state: any) =>
  state.getIn(['preFetchedData', 'translatedCourses', 'data']) ?? {};
